import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Wrapper, Slider, ISlideProps, Row, Column, Slide, Button, Contact } from '@adac-mp/components';
import { DkvContext, OfferContext, getUrlBasePath } from '@adac-mp/shared';
import { useViewport } from '@adac-mp/components/src/hooks/useViewport';
import Step0Mobile from '../../assets/images/Step0-mobil.svg';
import Step0Desktop from '../../assets/images/Step0-desktop.svg';
import Step1Desktop from '../../assets/images/Step1-desktop.svg';
import Step1 from '../../assets/images/Step1.svg';
import Step2 from '../../assets/images/Step2.svg';

export const Walkthrough = () => {
	const navigate = useNavigate();
	const { viewport } = useViewport();
	const { resetDkv } = useContext(DkvContext);
	const { updateOffer } = useContext(OfferContext);
	useEffect(() => {
		sessionStorage.clear();
		resetDkv();
		updateOffer();
	}, []);

	const slides = [
		{
			image: viewport === 'mobile' ? Step0Mobile : Step0Desktop,
			title: `So geht's`,
			description:
				'Der erste Schritt zur Einrichtung Ihrer Camper Mautbox: das Hochladen Ihres Fahrzeugscheins. Alles, was Sie brauchen: Handykamera und gültigen Fahrzeugschein.',
		},
		{
			image: Step1,
			title: 'Fotografieren',
			description: 'Richten Sie den Fahrzeugschein an den Kanten Ihres Handyscreens aus.',
		},
		{
			image: Step1Desktop,
			title: 'Kontrollieren',
			description:
				viewport === 'mobile'
					? 'Achten Sie drauf, dass Sie den Schein vollständig, scharf und knitterfrei fotografieren.'
					: 'Prüfen Sie, ob der Fahrzeugschein auf Ihrem Bild vollständig, scharf und knitterfrei abgebildet ist.',
		},
		{
			image: Step2,
			title: 'Hochladen',
			description:
				viewport === 'mobile'
					? 'Alles im Bild? Dann können Sie Ihren Fahrzeugschein jetzt hochladen.'
					: 'Die Datei ist kleiner als 10 MB? Dann können Sie Ihren Fahrzeugschein jetzt hochladen.',
		},
	] as ISlideProps[];
	const [currentSlides, setCurrentSlides] = useState(slides);

	const onFinished = () => {
		navigate(getUrlBasePath('/camper-mautbox/configuration'));
	};

	useEffect(() => {
		if (viewport === 'desktop') {
			setCurrentSlides(slides.filter((slide) => slide.title !== 'Fotografieren'));
		} else {
			setCurrentSlides(slides);
		}
	}, [viewport]);

	return (
		<>
			{viewport === 'desktop' && (
				<Wrapper className="h-[calc(100vh_-_98px)] bg-white" innerClass="justify-between">
					<Row>
						{currentSlides.map((slide, index) => (
							<Column key={index} className="md:basis-1/4">
								<Slide
									step={index + 1}
									image={slide.image}
									title={slide.title}
									description={slide.description}
								/>
							</Column>
						))}
					</Row>
					<div className="static bottom-0 left-0 right-0 w-full flex justify-center items-end">
						<Button className="w-2/12 h-fit mb-8" onClick={onFinished}>
							Los geht's
						</Button>
					</div>
				</Wrapper>
			)}
			{viewport === 'mobile' && <Slider slides={currentSlides} onFinished={onFinished} />}
			<Contact withSeparator />
		</>
	);
};
